import type { ComponentType, SVGProps } from 'react';
import AiIcon1 from './AiIcon1';
import AiIcon2 from './AiIcon2';
import AiIcon3 from './AiIcon3';
import AiIcon4 from './AiIcon4';
import AiIcon5 from './AiIcon5';
import AiIcon6 from './AiIcon6';
import AiIcon7 from './AiIcon7';

// Single source of truth mapping a saved AI-icon selection to its component,
// shared by the merchant dashboard and the live widget. Keyed by the raw string
// literal (the API contract) so this UI library stays decoupled from the
// backend Icon enum.
export type AiIconKey =
  | 'icon1'
  | 'icon2'
  | 'icon3'
  | 'icon4'
  | 'icon5'
  | 'icon6'
  | 'icon7';

export const AI_ICON_KEYS: AiIconKey[] = [
  'icon1',
  'icon2',
  'icon3',
  'icon4',
  'icon5',
  'icon6',
  'icon7',
];

export const DEFAULT_AI_ICON_KEY: AiIconKey = 'icon7';

export const AI_ICON_COMPONENTS: Record<
  AiIconKey,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  icon1: AiIcon1,
  icon2: AiIcon2,
  icon3: AiIcon3,
  icon4: AiIcon4,
  icon5: AiIcon5,
  icon6: AiIcon6,
  icon7: AiIcon7,
};

export const resolveAiIconKey = (raw: string | undefined): AiIconKey =>
  raw && (AI_ICON_KEYS as string[]).includes(raw)
    ? (raw as AiIconKey)
    : DEFAULT_AI_ICON_KEY;
